import { createSlice } from "@reduxjs/toolkit";

import { type FormStateType } from "../interfaces/form";

const initialState: FormStateType = {
  isLoading: false,
  forms: [],
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setFormLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setForms: (state, action) => {
      state.forms = action.payload;
    },
  },
});

export const { setFormLoading, setForms } = formSlice.actions;
export default formSlice.reducer;
